/**
 * use-payment-method-options — paymentMethodOptionsApi（ADM-PAY-S013 可选支付方式 + Stripe 同步）
 *
 * 契约源 dev-docs `02-API契约/A8-运营支付.md` §7.8.8 / §7.8.9。可选支付方式 = 平台适用的固定子集 ∪
 * 该 App 全部 Stripe 同步行；后台的策略成员候选与图标配置入口**只取这里列出的取值**，不提供手输。
 *
 * 同步（POST）只写同步表：不增删策略成员、不动图标；失败保留上次结果。后台手动同步与打开支付方式
 * 配置页时的自动同步都走它，无写权限的账号只读 GET。
 */

import type { PaymentMethodOptionsResponse } from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const paymentMethodOptionsApi = {
  /** 列某 App 的可选支付方式（§7.8.8，viewer+，只读本库、不调用 Stripe）*/
  list: (appId: string) =>
    apiRequest<PaymentMethodOptionsResponse>({
      method: 'GET',
      path: '/api/v1/payment-method-options',
      query: { app_id: appId },
    }),
  /** 从该 App 的 Stripe 账户同步支付方式（§7.8.9，operator+ mfa）；返回同 §7.8.8 */
  syncStripe: (appId: string) =>
    apiRequest<PaymentMethodOptionsResponse>({
      method: 'POST',
      path: '/api/v1/payment-method-options/stripe-sync',
      body: { app_id: appId },
    }),
};
